<template lang="pug">
  section#sidebar
    Menu#sb-main-menu(k="main-menu" :max-depth="2")
    Menu#sb-header-menu(k="header-menu" :max-depth="1")
    Menu#sb-footer-menu(k="footer-menu" :max-depth="1")
</template>

<script>
import Menu from '@/components/Menu.vue';

export default {
    name: 'Sidebar',
    components: {
        Menu
    },
    mounted() {
        this.$emit('mounted');
    }
};
</script>

<style lang="sass" scoped>
section#sidebar
  background-color: #1D1F20
  background-image: linear-gradient(145deg, #1D1F20, #404348)

  ::v-deep nav
    ul.tree-menu
      li
        // &.visible
        & > ul
          &.tree-menu
            border-left: 3px solid rgba(255, 255, 255, .1)
            margin-left: 22px
        a
          padding: 10px 20px
          display: block
          color: #fff
          &:hover
            background-color: rgba(255, 255, 255, 0.1)
        .tree-item
          display: flex
          & > a
            flex-grow: 1
          & > button
            width: 40px
            background: transparent
            border: none
            outline: none
            color: white
            font-size: 1rem
            & > i
              font-family: "Font Awesome 5 Free"
              font-weight: 900
              text-decoration: none
              font-style: normal
              &.is-closed:before
                content: "\f078"
              &.is-open:before
                content: "\f077"
      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
        transform-origin: left center
        max-height: 500px
        overflow: hidden
      .show-enter, .show-leave-to
        opacity: 0
        max-height: 0
        transform: translateX(-15px)
</style>
